import { useParams } from "react-router-dom";
import { Link as ChakraLink } from "@chakra-ui/react";
import {
  Grid,
  GridItem,
  Text,
  Box,
  VStack,
  Heading,
  Divider,
} from "@chakra-ui/react";
import { useEffect } from "react";
import Title from "../components/Title";
import Topic from "../components/Topic";
import Sessions from "../data/Sessions";
import Cases from "../data/Cases";
import ReturnTopButton from "../components/Returntopbutton";

export default function SessionDetail() {
  const { id } = useParams();
  const session = Sessions.find((s) => s.id === id);
  const chosenCases = Cases.filter((c) => c.title === session?.title);

  useEffect(() => {
    if (session?.title) {
      document.title = session.title;
    } else {
      document.title = "セッション詳細";
    }
  }, [session]);

  return (
    <Grid
      maxW="900px"
      mx="auto"
      px={4}
      py={8}
      alignItems="start"
    >
      <GridItem mr={4}>
        <VStack align="stretch" >

          <Box>
            {session?.title ? (
              <Topic title={session.title}>
                <></>
              </Topic>
            ) : (
              <Text color="red.500" fontWeight="bold">
                セッションが見つかりません。
              </Text>
            )}
          </Box>

          {chosenCases.length > 0 && (
            <Box mx={4}>
              <VStack align="stretch">
                {chosenCases.map((chosencase) => (
                  <Box key={chosencase.caseid} mb={4}>
                    <ChakraLink
                      key={chosencase.caseid}
                      href={chosencase.link}
                      color="blue.700"
                      fontWeight="bold"
                      _hover={{ textDecoration: "underline" }}
                    >
                      {chosencase.casetitle}
                    </ChakraLink>
                    <Text fontSize={13}>{chosencase.reader}</Text>
                  </Box>
                ))}
              </VStack>
            </Box>
          )}
        </VStack>
        <Box mt={12}>
          <ReturnTopButton />
        </Box>
      </GridItem>
    </Grid>
  );
}
